import { ModuleRequestError } from '@wit-support/admin-client-core';
/**
 * Запросы раздела уходят в auto-ads и дальше в Meta с общим лимитом: не
 * перечитываем при возврате во вкладку, повторяем только сеть и 5xx и не
 * больше одного раза (отказ, 429 и ответ Meta — никогда).
 */
export function shouldRetry(failureCount, error) {
    if (failureCount >= 1)
        return false;
    if (error instanceof ModuleRequestError) {
        if (error.status < 500)
            return false;
        if (error.code === 'upstream_rejected' || error.code === 'ads_not_configured')
            return false;
        return true;
    }
    return error instanceof TypeError;
}
export const QUERY_DEFAULTS = {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: shouldRetry,
};
export const REFERENCE_STALE_MS = 5 * 60_000;
export const LIST_STALE_MS = 30_000;
//# sourceMappingURL=query-policy.js.map